(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    const SELECTOR = '.accordion[data-single-open]';

    function closeOthers(accordion, openedDetails) {
      accordion.querySelectorAll('details[open]').forEach(function (details) {
        if (details !== openedDetails) details.removeAttribute('open');
      });
    }

    function initAccordion(accordion) {
      // On load: keep only the first open row, close the rest
      const openRows = Array.from(accordion.querySelectorAll('details[open]'));
      openRows.slice(1).forEach(function (details) {
        details.removeAttribute('open');
      });

      // toggle doesn't bubble, use capture phase
      accordion.addEventListener(
        'toggle',
        function (event) {
          if (event.target.tagName === 'DETAILS' && event.target.open) {
            closeOthers(accordion, event.target);
          }
        },
        true
      );
    }

    function init() {
      document.querySelectorAll(SELECTOR).forEach(initAccordion);
    }

    // Re-init when a block is added/changed in the theme editor
    document.addEventListener('shopify:section:load', init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    (function () {
    const PARALLAX_STRENGTH = 40;
    const SELECTOR = '.image-block--animation-parallax-scroll';

    function updateParallax(block) {
      const rect = block.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const progress = 1 - rect.bottom / (viewportHeight + rect.height);
      const offset = (progress - 0.5) * PARALLAX_STRENGTH * 2;
      block.style.setProperty('--parallax-offset', `${offset}px`);
    }

    function onScroll() {
      document.querySelectorAll(SELECTOR).forEach(updateParallax);
    }

    function initParallax() {
      if (!document.querySelector(SELECTOR)) return;
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Re-run when a block is added/changed in the theme editor
    document.addEventListener('shopify:block:select', function (event) {
      const block =
        event.target.querySelector(SELECTOR) ||
        (event.target.matches(SELECTOR) ? event.target : null);
      if (block) updateParallax(block);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initParallax);
    } else {
      initParallax();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
